<template>
  <z-form ref="form" class="w-100">
    <div class="row">
      <div class="col-12">
        <div class="z-card">
          {{ $t('projects.import.title', { filename: file_name }) }}
          <h2>{{ $t('projects.imports.field.desc') }}</h2>

          <div class="row">
            <div class="col-6 mt-4">
              <ul class="b-select-fields">
                <li v-for="(item, index) in file_content" :key="item.name">
                  <label>
                    {{ item }}
                  </label>
                  <i-select :clearable="true" @on-change="(value) => changeCheckbox(value, index)">
                    <i-option
                      v-for="(field, name) in fields_title"
                      :key="`${item}-${field}-key`"
                      :value="name"
                      :label="field"
                      :disabled="isDisabled(name)"
                    />
                  </i-select>
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-6 mt-4">
              {{ $t('projects.sources.table.field.user_group') }}

              <z-form-input :rules="{ required: true }">
                <i-select v-model="group_id" @input="update_group_info">
                  <i-option
                    v-for="(item, key) in groupList"
                    :key="key"
                    :value="item.id"
                    :label="item.name"
                  />
                </i-select>
              </z-form-input>
              <p class="mt-2" style="height: 21px">
                <span v-if="processing_mode">
                  {{ $t(`projects.create_task.modal_add_source.method.${processing_mode}`) }}
                </span>
                <span v-if="users_in_group && users_in_group.length > 0">
                  {{ $t('shared.users') }}:
                  <template v-for="(name, i) in users_in_group">
                    <template v-if="i < 2"> {{ name.name }}, </template>
                    <template v-if="i === 2">
                      {{ name.name }}
                    </template>
                  </template>
                  <template v-if="users_in_group.length > 2">
                    <span class="pointer bold" @click="toGroup">
                      {{ $t('shared.and_more') }} {{ users_in_group.length - 3 }}
                    </span>
                  </template>
                </span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6 mt-4">
              <checkbox v-model="ignore_header" class="m-0" type="warning" border>
                {{ $t('db.import.create.button.ignore_header') }}
              </checkbox>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="btn-wrapper col-12">
            <i-button size="large" @click="$router.go(-1)">
              {{ $t('shared.component.button.cancel') }}
            </i-button>
            <i-button
              class="btn-import"
              :loading="is_loading"
              type="primary"
              size="large"
              @click="save_import"
            >
              {{ $t('projects.import.make_import') }}
            </i-button>
          </div>
        </div>
      </div>
    </div>
  </z-form>
</template>

<script>
  import { TasksService } from '@tasks/services/TasksService';
  import { GroupService } from '@administration/services/GroupService';

  export default {
    data: () => ({
      group_id: '',
      groupList: [],
      columns: {},
      file_content: [],
      disabled_fields: [],
      ignore_header: false,
      is_loading: false,
      fields_title: {
        task_date: 'Дата задачи',
        task_state_id: 'Статус задачи',
        items: 'Товары',
        customer_name: 'ФИО',
        customer_email: 'Email',
        customer_phone: 'Телефон',
        customer_country: 'Страна',
        customer_region: 'Регион',
        customer_city: 'Город',
        customer_zip: 'Индекс',
        customer_address: 'Адрес',
        task_id: 'UUID',
        comments: 'Комментарий',
        field_1: 'Поле #1',
        field_2: 'Поле #2',
        field_3: 'Поле #3',
        field_4: 'Поле #4',
        field_5: 'Поле #5',
        field_6: 'Поле #6',
        field_7: 'Поле #7',
        field_8: 'Поле #8',
        field_9: 'Поле #9',
        field_10: 'Поле #10',
        field_11: 'Поле #11',
        field_12: 'Поле #12',
        field_13: 'Поле #13',
        field_14: 'Поле #14',
        field_15: 'Поле #15'
      },
      users_in_group: [],
      processing_mode: ''
    }),

    computed: {
      project_id() {
        return this.$route.params.project_id;
      },
      file_id() {
        return this.$route.params.file_id;
      },
      file_name() {
        return this.$route.params.file_name;
      },
      disabled_send() {
        return !(Object.keys(this.disabled_fields).length > 0);
      },

      recipient_fields() {
        const field_keys = Object.keys(this.$t('projects.import.field'));
        const selected_keys = Object.values(this.file_content);

        return field_keys.map((i) => ({
          key: i,
          value: this.$t(`projects.import.field.${i}`),
          disabled: selected_keys.includes(i)
        }));
      }
    },

    async created() {
      await GroupService.getList().then((resp) => (this.groupList = resp.data));
      await TasksService.importFilePreview(
        this.$route.params.project_id,
        this.$route.params.file_id
      ).then((resp) => {
        this.file_content = resp.rows[0];
      });
      this.update_group_info();
    },

    methods: {
      toGroup() {
        setTimeout(() => {
          this.$router.push({
            name: 'administration.usergroup.index',
            params: { groupId: this.group_id }
          });
        }, 300);
      },
      changeCheckbox(value, index) {
        for (let prop in this.columns) {
          if (this.columns[prop] === index) {
            delete this.columns[prop];
            this.disabled_fields.splice(this.disabled_fields.indexOf(prop), 1);
          }
        }

        this.columns[value] = index;
        this.disabled_fields.push(value);
      },

      isDisabled(name) {
        return this.disabled_fields.includes(name);
      },

      save_import() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const columns = this.columns;
            const ignore_header = this.ignore_header;
            const group_id = this.group_id;

            TasksService.saveImport(this.$route.params.project_id, this.file_id, {
              group_id,
              columns,
              ignore_header
            })
              .then(() => {
                this.$router.push({
                  name: 'projects.import.create',
                  params: {
                    id: this.project_id
                  }
                });
              })
              .catch((error) => {
                this.$noty.server_error(error);
              });
          }
        });
      },

      update_group_info() {
        GroupService.getFullList(this.group_id)
          .then((resp) => {
            this.processing_mode = resp.processing_mode;
            this.users_in_group = resp.users;
          })
          .catch((error) => {
            this.$noty.server_error(error);
          });
      }
    }
  };
</script>

<style lang="scss">
  ul.b-select-fields {
    list-style: none;
    display: block;
    margin-top: 20px;

    li {
      width: 100%;
      display: flex;
      margin-top: 10px;

      label {
        width: 30%;
      }

      span {
        margin-right: 5px;
      }
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 15px;
    }

    .btn-import {
      width: 174px;
      max-width: 174px !important;
    }
  }
</style>
